import { Controller } from '@hotwired/stimulus';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import mapboxgl from 'mapbox-gl';
import axios from 'axios';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { debounce } from 'lodash';

let map;
let geocoder;
let activeBranchId;
const mapboxId = '2b3gkdsp';

export default class extends Controller {
    static targets = [
        'searchInput',
    ];

    initialize() {
        this.searchByTerm = debounce(this.searchByTerm, 500).bind(this);

        const center = [6.467777, 50.799156];
        map = this.#createMap(center);
        map.on('load', () => {
            geocoder = this.#createGeoCoder();
            this.#createMarkersForAllBranches();

            geocoder.on('result', async (event) => {
                const point = event.result.center;
                const tileSetId = `maarten-webkick.${mapboxId}`;
                const radius = 50000;
                const limit = 50;
                const query = await fetch(
                    `https://api.mapbox.com/v4/${tileSetId}/tilequery/${point[0]},${point[1]}.json?radius=${radius}&limit=${limit}&access_token=${mapboxgl.accessToken}`,
                    { method: 'GET' }
                );
                const json = await query.json();
                await this.#getSearchResultBranches(json.features, activeBranchId);

                map.getSource('tilequery').setData(json);
            });

            this.#addNewSourceToMap(map);
            document.querySelector('#map-search').appendChild(geocoder.onAdd(map));
        });
    }

    #createMap(center) {
        mapboxgl.accessToken = 'pk.eyJ1IjoibWFhcnRlbi13ZWJraWNrIiwiYSI6ImNsajdrMHNycjB2NW0zZHBhNjdydWNlM3UifQ.Nobx7Sf_I-Dl2MkSR6IByA';
        return new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v12',
            center: center,
            zoom: 5,
            maxZoom: 18,
            language: 'de',
        });
    }

    #createGeoCoder() {
        return new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            marker: false,
            countries: 'de,at',
            language: 'de',
        });
    }

    #createMarkersForAllBranches() {
        axios.get('/branches')
            .then(response => {
                const branches = response.data;
                branches.forEach((branch) => {
                    new mapboxgl.Marker({ color: '#FEDD08' })
                        .setLngLat([
                            branch.longitude,
                            branch.latitude,
                        ])
                        .setPopup(new mapboxgl.Popup({ offset: 15 }).setHTML(
                            `
                                <div style="color: #878787">
                                    <div>
                                        <img src="https://api.eezybridge.com/WebGetAssetService.svc/GetAssetByFileName/0f5061a8-4c32-47e7-b069-d8b0267ba04e/${branch.image}" style="max-height: 40px; max-width: 150px">
                                    </div>
                                    <br>
                                    <a class="alert-link" href="${branch.website}" target="_blank"><p style="color: #575757; border: none; margin-bottom: 0;">${branch.name}</p></a>
                                    <p>${branch.companyType}</p>
                                    ${branch.address} <br>
                                    ${branch.zipCode} ${branch.city} <br>
                                    Tel.: ${branch.phone} <br>
                                    Email: <a class="alert-link" href="mailto:${branch.email}" style="color: #575757">${branch.email}</a><br>
                                </div>
                            `
                        )).addTo(map);
                });
            })
            .catch(err => console.log(err));
    }

    #addNewSourceToMap(map) {
        map.addSource('tilequery', {
            // Add a new source to the map style: https://docs.mapbox.com/mapbox-gl-js/api/#map#addsource
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
    }

    #getBranchIds(features) {
        const branchIds = [];
        for (const branch of features) {
            const displayBranchId = branch.properties.displayBrancheId;
            if (!branchIds.includes(displayBranchId)) {
                branchIds.push(displayBranchId);
            }
        }

        return branchIds;
    }

    async #getSearchResultBranches(features, activeBranchId) {
        const branchIds = this.#getBranchIds(features);
        const response = await axios.post('/branches/search', { branchIds, activeBranchId });

        return Turbo.renderStreamMessage(response.data);
    }

    async searchBranch(event) {
        event.preventDefault();
        const { zipcode, branchId } = event.currentTarget.dataset;
        activeBranchId = branchId;
        await geocoder.query(zipcode);
    }

    async searchByTerm(event) {
        event.preventDefault();
        if (this.searchInputTarget.value.length === 0) {
            this.#resetMapAndSearchResults();
            return;
        }

        await geocoder.query(this.searchInputTarget.value);
    }

    #resetMapAndSearchResults() {
        map.setZoom(5).setCenter([6.467777, 50.799156]);
        document.querySelector('#branch-search-results').innerHTML = `
                <p>
                    Finde jetzt deine ELTROPA Händler vor Ort. <br>
                    Einfach die entsprechende Postleitzahl eingeben und den ELTROPA Händler in deiner Nähe ausfindig machen.
                </p>
            `;
    }

    disconnect() {
        map.remove();
    }
}
